import React from 'react'
import { Divider } from 'antd'
import { CustomTag } from 'src/components'
import { useTranslation } from 'next-i18next'

interface EmailTabsProps {
  loadingValidateEmail: boolean
  isUserEmailInvalid: boolean
  errorEmailValidation: string
  successEmailValidation: boolean
}


const EmailTabs: React.FC<EmailTabsProps> = (props) => {
  const { t } = useTranslation()
  const {
    loadingValidateEmail, isUserEmailInvalid,
    errorEmailValidation, successEmailValidation
  } = props

  return <>
    {loadingValidateEmail ? <>
      <CustomTag type='processing' text={t('admin.Brokerage.EmailMessages.ValidateEmail')} />
      <Divider />
    </> : isUserEmailInvalid ?  <>
      <CustomTag type='error' text={t(`admin.Brokerage.EmailMessages.${errorEmailValidation}`)} />
      <Divider />
    </> : successEmailValidation && <>
      <CustomTag type='success' text={t('admin.Brokerage.EmailMessages.SUCCESS')} />
      <Divider />
    </>}
  </>
}

export default EmailTabs
